import { accumulated } from './accumulated';
import { campaign } from './campaign';
import { optin } from './optin';
import { ranking } from './ranking';
import { sso } from './sso';

export const incentiveCampaign = {
  optin,
  ranking,
  accumulated,
  sso,
  campaign,
};
